import { ArrowRight } from 'lucide-react'
import { Link, useOutletContext, useParams } from 'react-router-dom'

function formatDateTime(dateTimeString) {
  const dateObj = new Date(dateTimeString)

  // Extract Date (DD-MM-YYYY)
  const day = String(dateObj.getDate()).padStart(2, '0')
  const month = String(dateObj.getMonth() + 1).padStart(2, '0') // Months are 0-based
  const year = dateObj.getFullYear()
  const formattedDate = `${day}-${month}-${year}`

  // Extract Time in 12-hour format with AM/PM
  let hours = dateObj.getHours()
  const minutes = String(dateObj.getMinutes()).padStart(2, '0')
  const amPm = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12 || 12 // Convert to 12-hour format

  const formattedTime = `${hours}:${minutes} ${amPm}`

  return { formattedDate, formattedTime }
}

const UpcomingLiveClassesSectionV2 = () => {
  const { moduleIndex, contentIndex } = useParams()
  const { modules } = useOutletContext()

  const class_ = modules[moduleIndex].contents[contentIndex]

  return (
    <div className="border p-4 lg:p-7 bg-white rounded-lg w-full space-y-4 h-fit">
      <img
        src="https://s3.brilliant.com.bd/blog-bucket/thumbnail/2384fcdd-12a3-4223-9ded-d9db9651c848.png"
        alt="Zoom Icon"
        className="size-12 aspect-square "
      />
      <div className="flex justify-between">
        <p className="text-3xl font-bold">{class_.lectureName}</p>
      </div>
      <p className="w-full bg-gray-200 p-2 rounded-lg flex items-center gap-2 overflow-auto">
        <span>Link:</span>
        <span className="w-full line-clamp-1">{class_.liveClassLink}</span>
      </p>
      <div className="flex justify-between gap-2 lg:gap-6 flex-wrap">
        <p className="flex flex-col">
          <p>
            <strong>Date: </strong>
            {formatDateTime(class_.liveClassStartTime).formattedDate}
          </p>

          <p>
            <strong>Time:</strong> {formatDateTime(class_.liveClassStartTime).formattedTime}
          </p>
        </p>
        <Link
          to={class_.liveClassLink}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-blue px-6 py-2.5 min-w-fit rounded-lg text-white flex items-center gap-2">
          <span>Join Class</span>
          <ArrowRight className="size-5" />
        </Link>
      </div>
    </div>
  )
}

export default UpcomingLiveClassesSectionV2
